import {GlobalService} from "@/services/GlobalService";
import {
  ACCIDENT_INCIDENT, AUDIT,
  AUDIT_DUE_COUNTS, AUDIT_DUE_PLAN, AUDIT_DUE_APPOINTMENT_DETAILS,
  AUDIT_DUES,
  AUDIT_DUES_COUNT, AUDIT_DUES_DOWNLOAD, AUDIT_DUES_SPECIFIC_COLUMN,
  AUDITOR_CERTIFICATE,
  AUDITOR_INDEX,
  AUDITS,
  AUDITS_SETTINGS,
  COMPANY_DELETE_OBJECTIVE_EVIDENCE, DELETE_ATTENDANCE, DELETE_AUDIT_FILE, DELETE_CHECKLIST,
  DELETE_NON_CONFORMITY,
  DELETE_OBJECTIVE_EVIDENCE, DESIGNATED_PERSON, DIRECTOR_SECURITY,
  DOWNLOAD_DOCUMENT, GET_IA_APPOINTMENT_DETAILS_BY_TYPE_AND_ID,
  IA_REPORTS_BY_TYPE,
  LATEST_OBJECTIVE_EVIDENCES,
  NON_CONFORMITIES,
  NON_CONFORMITIES_OE, NON_CONFORMITIES_ORDER,
  OE_AFTER_ATTACHMENTS,
  OE_BEFORE_ATTACHMENTS,
  OE_CATEGORIES_LIST,
  PSC_INDEX,
  ROOT_CAUSES_LIST, UPDATE_IA_APPOINTMENT_DETAILS,
  UPDATE_IA_REPORT_TYPE_BY_ID, UPDATE_ICBT_SCORE,
  UPDATE_NON_CONFORMITIES,
  UPDATE_OBJECTIVE_EVIDENCE,
  VESSEL_AUDITS,
  VESSEL_DETAIL, DELETE_MASTER_SIGNATURE, DOWNLOAD_PSC_MONTHLY_SUMMARY
} from "@/services/ConstantService";
import axios from "axios";

import da from "vue2-datepicker/locale/es/da";
import {AlertService} from "@/services/AlertService";

const state = {
  // start of audit records data section
  vesselAuditRecord: [],
  selectedAuditRecord : {
    sms : null,
    isps : null,
    cyber : null,
  },
  // end of audit records data section

  // start of internal audit report data section
  internal_audit_reports : {
    sms : null,
    isps : null,
    cyber : null,
  },

  director_security : {
    sms : [],
    isps : [],
    cyber : [],
  },

  // end of internal audit report data section

  // start of non-conformities data section
  nonConformities : {
    sms : null,
    isps : null,
    cyber : null,
  },

  nonConformityType : {
    sms : null,
    isps : null,
    cyber : null,
  },
  observationNoteType : {
    sms : null,
    isps : null,
    cyber : null,
  },




  root_causes_list : {
    sms : [],
    isps : [],
    cyber : [],
  },
  // end of non-conformities data section

  // start of objective evidence data section
  oECategories : [],
  latestOeLists : [],

  vessel_audit_dues : [],

  // end of objective evidence data section

  // start of audit due data section
  vessel_audit_dues_count : {
    sms : {
      overdue : {
        count : 0,
        ids : [],
        requesting : true,
      },
      '90days' : {
        count : 0,
        ids : [],
        requesting : true,
      },
      '30days' : {
        count : 0,
        ids : [],
        requesting : true,
      }
    },
    isps : {
      overdue : {
        count : 0,
        ids : [],
        requesting : true,
      },
      '90days' : {
        count : 0,
        ids : [],
        requesting : true,
      },
      '30days' : {
        count : 0,
        ids : [],
        requesting : true,
      }
    },
    cyber : {
      overdue : {
        count : 0,
        ids : [],
        requesting : true,
      },
      '90days' : {
        count : 0,
        ids : [],
        requesting : true,
      },
      '30days' : {
        count : 0,
        ids : [],
        requesting : true,
      }
    }
  },
  reportTypeStatusKeys : [],
  ia_appointment_details : '',
  designated_persons: [],
  newAppointmentAuditDueRefs: [],

  updated_report_status_names : [
    {
      id : 1,
      code: "new",
      name: "APPOINTED",
      color : '42b983'
    },
    {
      id : 2,
      code: "open",
      name: "IN PROGRESS",
      color : '056cb4'
    },
    {
      id : 4,
      code: "ready-to-close",
      name: "READY TO CLOSE",
      color : '042454'
    },
    {
      id : 3,
      code: "closed",
      name: "CLOSED",
      color : '4c4c4c'
    },
    {
      id : 5,
      code: "record-only",
      name: "RECORD ONLY",
      color : 'bc8526'
    }
  ]
}

const actions = {
  // START OF VESSEL AUDIT RECORDS SECTION
  async getVesselAuditRecordList({ commit }, params) {
    const uri = VESSEL_AUDITS.replace('{vessel_id}', params.vessel_id) + '?page=' + params.page;
    const response = await GlobalService.ajax('post', uri, {params});
    const data = response?.data;
    commit('SET_AUDIT_RECORD', data?.data);
    commit('setPagination', data?.meta)
  },
  async getVesselAuditRecordById({ commit }, auditRecordId) {
    const uri = AUDITS + `/${auditRecordId}`
    return await axios['get'](uri).then(response => {
      const data = response?.data;
      commit('SET_SELECTED_AUDIT_RECORD', data?.data);
      return response.data ?? false
    }).catch(error => {
      return false;
    });
  },
  async deleteAuditRecord({ commit }, params) {
    return await axios.delete(AUDITS +`/${params.audit_type}/${params.audit_type_id}`,{data:params}).then(response => {
      if (response.hasOwnProperty('status') && response.status === 200) {
        return true;
      }
      return response;
    }).catch(error => {
      if(error.response.status === 500){
        GlobalService.handleError(error, 'DELETE REPORT SERVICE')
      }
      return error.response.data
    })
  },
  async createAuditRecord({ commit }, params) {
    const response = await GlobalService.ajax('post', AUDITS, params);
    if (response.hasOwnProperty('status') && response.status === 201) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message,
      errors : response.errors
    };
  },
  async updateAuditSettings({ commit }, params){
    const response = await GlobalService.ajax('post', AUDITS_SETTINGS, params);

    if (response.hasOwnProperty('status') && response.status === 200) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message
    };
  },
  async updateAuditRecord({ commit }, params) {
    const uri = [AUDITS, params.id].join('/') + '?_method=PUT';

    const response = await GlobalService.ajax('post', uri, params.form_data);

    if (response.hasOwnProperty('status') && response.status === 200) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message
    };
  },

  async deleteAuditFile({ commit }, params) {
    let uri = DELETE_AUDIT_FILE.replace('{audit_id}', params.id).replace('{type}', params.type);

    return await axios.delete(uri, {data:params}).then(response => {
      if (response.hasOwnProperty('status') && response.status === 200) {
        return true;
      }
      return response;
    }).catch(error => {
      if(error.response.status === 500){
        GlobalService.handleError(error, 'DELETE FILE SERVICE')
      }
      return error.response.data
    })
  },


  // END OF VESSEL AUDIT RECORDS SECTION

  // START OF INTERNAL AUDIT SECTION
  async getInternalAudit({ commit }, params) {
    const uri = IA_REPORTS_BY_TYPE.replace('{type}', params.type).replace('{id}', params.id);
    const response = await GlobalService.ajax('get', uri);

    if (response.hasOwnProperty('status') && response.status === 200) {
      const data = response?.data;
      commit('SET_INTERNAL_AUDIT', {
        type : params.type,
        value : data?.data
      });
    }
  },
  async updateInternalAuditReport({ commit }, params) {
    const uri = UPDATE_IA_REPORT_TYPE_BY_ID.replace('{audit_report}', params.id) + '?_method=PUT';
    const response = await GlobalService.ajax('post', uri, params.form);
    if (response.hasOwnProperty('status') && response.status === 200) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message
    };

  },

  async deleteInternalAuditFile({ commit }, params) {
    let uri = DELETE_ATTENDANCE.replace('{audit_report}', params.id);

    if (params.type === 'checklist') {
      uri = DELETE_CHECKLIST.replace('{audit_report}', params.id);
    }

    if (params.type === 'master_signature') {
      uri = DELETE_MASTER_SIGNATURE.replace('{audit_report}', params.id);
    }

    const newParam = {
      ids : params.ids
    };

    return await axios.delete(uri, {data:newParam}).then(response => {
      if (response.hasOwnProperty('status') && response.status === 200) {
        return true;
      }
      return response;
    }).catch(error => {
      if(error.response.status === 500){
        GlobalService.handleError(error, 'DELETE FILE SERVICE')
      }
      return error.response.data
    })
  },

  async getDirectorSecurity({ commit}, params) {
    const uri = DIRECTOR_SECURITY.replace('{type}', params.type).replace('{id}', params.id);
    const response = await GlobalService.ajax('get', uri);

    if (response.hasOwnProperty('status') && response.status === 200) {
      const data = response?.data;

      commit('SET_DIRECTOR_SECURITY', {
        type : 'sms',
        value : data?.data.sms
      });
      commit('SET_DIRECTOR_SECURITY', {
        type : 'isps',
        value : data?.data.isps
      });
      commit('SET_DIRECTOR_SECURITY', {
        type : 'cyber',
        value : data?.data.cyber
      });
    }
  },

  async downloadAuditDocument({ commit }, params) {
    const formParamData = new FormData();
    const keys = [
      'file',
      'has_checklist_feature'
    ];

    for (let key in params) {
      if (keys.includes(key)) {
        formParamData.append(key, params[key]);
      }

      if (key === 'ncr_obs_image_files') {
        params[key].forEach((item, item_index) => {
          formParamData.append(`ncr_obs_images[${item_index}]`, item);
        })
      }
    }

    return await axios.post(DOWNLOAD_DOCUMENT.replace('{audit_id}', params.audit_id).replace('{audit_type}', params.audit_type), formParamData, {
      responseType : 'blob'
    }).then(response => {
      return response;
    }).catch(error => {
      return {
        result : false,
        message : error.message,
      };
    })
  },

  // END OF INTERNAL AUDIT SECTION

  // START OF NON-CONFORMITY/OBSERVATION SECTION

  async getRootCausesList({ commit }, type) {
    const uri = ROOT_CAUSES_LIST.replace('{type}', type);
    const response = await GlobalService.ajax('get', uri);

    if (response.hasOwnProperty('status') && response.status === 200) {
      const data = response?.data;

      commit('SET_ROOT_CAUSES_LIST', {
        type : type,
        value : data
      });
    }
  },
  async getNonConformities({ commit }, params) {
    const uri = NON_CONFORMITIES.replace('{type}', params.type).replace('{id}', params.id);
    const response = await GlobalService.ajax('get', uri, {params});

    if (response.hasOwnProperty('status') && response.status === 200) {
      const data = response?.data;

      let nonConformityType = data?.data.filter(item => item.type === 'ncr');
      let observationNoteType = data?.data.filter(item => item.type === 'obs');


      // nonConformityType = await imageMixin.methods.convertNcrObsImagesToBase64(nonConformityType);
      // observationNoteType = await imageMixin.methods.convertNcrObsImagesToBase64(observationNoteType);

      commit('SET_NON_CONFORMITIES', {
        type : params.type,
        value : data?.data
      });

      commit('SET_NONCONFORMITY_TYPE_DATA', {
        type : params.type,
        value : nonConformityType
      });

      commit('SET_OBSERVATION_TYPE_DATA', {
        type : params.type,
        value : observationNoteType
      });
    }
  },
  async createNonConformities({ commit }, params) {
    const uri = NON_CONFORMITIES.replace('{type}', params.type).replace('{id}', params.id);
    delete params.id;
    delete params.type;
    const response = await GlobalService.ajax('post', uri, params);

    if (response.hasOwnProperty('status') && response.status === 200) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message,
      errors : response.errors
    };
  },
  async updateNonConformities({ commit }, params) {
    const uri = UPDATE_NON_CONFORMITIES.replace('{non_conformity}', params.id) + '?_method=PUT';
    const response = await GlobalService.ajax('post', uri, params);

    if (response.hasOwnProperty('status') && response.status === 200) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message
    };
  },

  async deleteNonconformity({ commit }, params) {
    return await axios.delete(DELETE_NON_CONFORMITY.replace('{non_conformity}', params.id), {data:params}).then(response => {
      if (response.hasOwnProperty('status') && response.status === 200) {
        return true;
      }
      return response;
    }).catch(error => {
      if(error.response.status === 500){
        GlobalService.handleError(error, 'DELETE REPORT SERVICE')
      }
      return error.response.data
    })
  },

  async getOECategoriesList({ commit }) {
    const response = await GlobalService.ajax('get', OE_CATEGORIES_LIST);

    if (response.hasOwnProperty('status') && response.status === 200) {
      const data = response?.data;
      commit('SET_OE_CATEGORIES', data);
    }
  },

  async getLatestObjectiveEvidences({ commit }, params) {
    const uri = LATEST_OBJECTIVE_EVIDENCES + '?filter[year]=' + params.year;
    delete params.year
    const response = await GlobalService.ajax('get', uri, {params});
    if (response.hasOwnProperty('status') && response.status === 200) {
      const data = response?.data;
      commit('SET_LATEST_OE_LISTS', data?.data);
      commit('setPagination',data)
    }
  },

  async downloadObjectiveEvidenceReport({ commit }, params) {
    try {
      const response = await axios.post(`${LATEST_OBJECTIVE_EVIDENCES}/download`, params, {
        responseType: 'blob',
      })

      if (response.hasOwnProperty('status') && response.status === 200) {
        return response?.data ?? false;
      }
    } catch (e) {
      throw e
    }
  },

  async createObjectiveEvidence({ commit }, params) {
    const uri = NON_CONFORMITIES_OE.replace('{non_conformity}', params.id);
    delete params.id;
    delete params.type;

    const response = await GlobalService.ajax('post', uri, params);

    if (response.hasOwnProperty('status') && response.status === 201) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message,
      errors : response.errors
    };
  },

  async updateObjectiveEvidence({ commit }, params) {
    const uri = UPDATE_OBJECTIVE_EVIDENCE.replace('{objective_evidence}', params.id) + '?_method=PUT';
    const response = await GlobalService.ajax('post', uri, params);

    if (response.hasOwnProperty('status') && response.status === 200) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message
    };
  },

  async deleteObjectiveEvidence({ commit }, params) {
    return await axios.delete(DELETE_OBJECTIVE_EVIDENCE.replace('{objective_evidence}', params.id), {data:params}).then(response => {
      if (response.hasOwnProperty('status') && response.status === 200) {
        return true;
      }
      return response;
    }).catch(error => {
      if(error.response.status === 500){
        GlobalService.handleError(error, 'DELETE REPORT SERVICE')
      }
      return error.response.data
    })
  },

  async updateOEImageAttachment({ commit }, params) {
    let uri = OE_BEFORE_ATTACHMENTS.replace('{objective_evidence}', params.id);

    if (params.type === 'after') {
      uri = OE_AFTER_ATTACHMENTS.replace('{objective_evidence}', params.id);
    }

    const response = await GlobalService.ajax('post', uri, params.data);
    if (response.hasOwnProperty('status') && response.status === 200) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message
    };
  },

  async deleteOeAttachments({ commit }, params) {
    let uri = OE_BEFORE_ATTACHMENTS.replace('{objective_evidence}', params.oe_id);

    if (params.type === 'after') {
      uri = OE_AFTER_ATTACHMENTS.replace('{objective_evidence}', params.oe_id);
    }

    return await axios.delete(uri, {data:params}).then(response => {
      if (response.hasOwnProperty('status') && response.status === 200) {
        return true;
      }
      return response;
    }).catch(error => {
      if(error.response.status === 500){
        GlobalService.handleError(error, 'DELETE REPORT SERVICE')
      }
      return error.response.data
    })
  },

  async updateOrderNumberFromList({ commit }, params) {

    let uri = NON_CONFORMITIES_ORDER.replace('{type}', params.type).replace('{id}', params.id);
    const response = await GlobalService.ajax('post', uri, params);

    if (response.hasOwnProperty('status') && response.status === 200) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message
    };
  },

  // END OF NON-CONFORMITY/OBSERVATION SECTION

  // START OF AUDIT DUES SECTION
  async getAuditDues({ commit }, params) {
    const for_audit_plan = params.for_audit_plan;
    const for_excel = params.excel;
    const response = await GlobalService.ajax('get', AUDIT_DUES, {params});
    if (response.hasOwnProperty('status') && response.status === 200) {
      const data = response?.data;
      if (for_excel === true) {
        return data;
      }
      if (for_audit_plan === true) {
        return data?.data;
      }
      commit('SET_AUDIT_DUES', data?.data);
      if (params.vessel_id === undefined) {
        commit('setPagination', data)
      }
    }
  },

  // GET AUDIT DUES SPECIFIC COLUMN
  async getAuditDuesSpecificColumn({ commit }, params) {

    const response = await GlobalService.ajax('get', AUDIT_DUES, {params});
    if (response.hasOwnProperty('status') && response.status === 200) {
      const data = response?.data;

      commit('SET_AUDIT_DUES_SPECIFIC_COLUMN', data?.data);
    }
  },

  async getAuditDueCounts({ commit }) {
    const response = await GlobalService.ajax('get', AUDIT_DUE_COUNTS);

    if (response.hasOwnProperty('status') && response.status === 200) {
      const data = response?.data;
      commit('SET_AUDIT_DUES_COUNT', data);
    }
  },

  async updateAuditDuePlanPlanByVesselId({ commit }, params) {
    const uri = AUDIT_DUE_PLAN.replace('{vessel}', params.vessel_id);
    const response = await GlobalService.ajax('patch', uri, params);
    if (response.hasOwnProperty('status') && response.status === 200) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message
    };
  },
  async downloadAuditDueExcel({ commit }, params) {
    return await axios.post(AUDIT_DUES_DOWNLOAD, params, {
      responseType : 'blob'
    }).then(response => {
      return response.data ?? false;
    }).catch(error => {
      return {
        result : false,
        message : error.message,
      };
    })
  },
  async updateAppointmentDetails({ commit }, params) {
    const uri = UPDATE_IA_APPOINTMENT_DETAILS.replace('{ia_appointment_report}', params.id) + '?_method=PUT';
    const response = await GlobalService.ajax('post', uri, params);
    if (response.hasOwnProperty('status') && response.status === 200) {
      return {
        result : true,
        data : response.data
      };
    }
    return {
      result : false,
      message : response.message
    };
  },
  async getAppointmentDetailsByTypeAndId({ commit }, params) {
    const uri = GET_IA_APPOINTMENT_DETAILS_BY_TYPE_AND_ID.replace('{id}', params.id).replace('{type}', params.type);
    const response = await GlobalService.ajax('get', uri, params);
    if (response.hasOwnProperty('status') && response.status === 200) {
      commit('SET_IA_APPOINTMENT_DETAILS', response.data)
    }
  },

  async getDesignatedPerson({ commit }) {
    const response = await GlobalService.ajax('get', DESIGNATED_PERSON);
    if (response.status === 200) {
      const data = response?.data;
      commit('SET_DESIGNATED_PERSON', data);
    }
  },

  async updateAuditDueAppointmentDetails({ commit }, params) {
    const response = await GlobalService.ajax('post', AUDIT_DUE_APPOINTMENT_DETAILS, params);

    if (response.hasOwnProperty('status') && response.status === 200) {
      return response?.data;
    }
  },
}

const mutations = {
  SET_AUDIT_RECORD : (state, vesselAuditRecord) => {
    state.vesselAuditRecord = vesselAuditRecord
  },
  SET_SELECTED_AUDIT_RECORD : (state, auditRecordData) => {
    state.selectedAuditRecord = auditRecordData;
  },
  SET_INTERNAL_AUDIT : (state, internalAuditData) => {
    state.internal_audit_reports[internalAuditData.type] = internalAuditData.value;
  },
  SET_NON_CONFORMITIES : (state, nonConformities) => {
    state.nonConformities[nonConformities.type] = nonConformities.value;
  },
  SET_ROOT_CAUSES_LIST : (state, root_causes) => {
    state.root_causes_list[root_causes.type] = root_causes.value;
  },
  SET_OE_CATEGORIES : (state, oECategories) => {
    state.oECategories = oECategories;
  },
  SET_LATEST_OE_LISTS : (state, latestOeLists) => {
    state.latestOeLists = latestOeLists;
  },
  SET_DIRECTOR_SECURITY : (state, data) => {
    state.director_security[data.type] = data.value;
  },
  SET_AUDIT_DUES : (state, vessel_audit_dues) => {
    state.vessel_audit_dues = vessel_audit_dues;
  },
  SET_AUDIT_DUES_SPECIFIC_COLUMN : (state, vessel_audit_dues_specific_column) => {
    const index = state.vessel_audit_dues.findIndex(val => val.id === vessel_audit_dues_specific_column[0]?.id)

    if(index !== -1){
      state.vessel_audit_dues.splice(index, 1, vessel_audit_dues_specific_column[0])
    }
  },
  SET_NEW_APPOINTMENT_AUDIT_DUE_REFS: (state, val) => {
    state.newAppointmentAuditDueRefs = val
  },
  SET_AUDIT_DUES_COUNT : (state, data) => {

    // update for SMS
    state.vessel_audit_dues_count.sms.overdue.count = data.sms.overdue.count;
    state.vessel_audit_dues_count.sms.overdue.ids = data.sms.overdue.ids;
    state.vessel_audit_dues_count.sms.overdue.requesting = false;
    state.vessel_audit_dues_count.sms['30days'].count = data.sms['30days'].count;
    state.vessel_audit_dues_count.sms['30days'].ids = data.sms['30days'].ids;
    state.vessel_audit_dues_count.sms['30days'].requesting = false;
    state.vessel_audit_dues_count.sms['90days'].count = data.sms['90days'].count;
    state.vessel_audit_dues_count.sms['90days'].ids = data.sms['90days'].ids;
    state.vessel_audit_dues_count.sms['90days'].requesting = false;

    // update for ISPS
    state.vessel_audit_dues_count.isps.overdue.count = data.isps.overdue.count;
    state.vessel_audit_dues_count.isps.overdue.ids = data.isps.overdue.ids;
    state.vessel_audit_dues_count.isps.overdue.requesting = false;
    state.vessel_audit_dues_count.isps['30days'].count = data.isps['30days'].count;
    state.vessel_audit_dues_count.isps['30days'].ids = data.isps['30days'].ids;
    state.vessel_audit_dues_count.isps['30days'].requesting = false;
    state.vessel_audit_dues_count.isps['90days'].count = data.isps['90days'].count;
    state.vessel_audit_dues_count.isps['90days'].ids = data.isps['90days'].ids;
    state.vessel_audit_dues_count.isps['90days'].requesting = false;

    // update for CYBER
    state.vessel_audit_dues_count.cyber.overdue.count = data.cyber.overdue.count;
    state.vessel_audit_dues_count.cyber.overdue.ids = data.cyber.overdue.ids;
    state.vessel_audit_dues_count.cyber.overdue.requesting = false;
    state.vessel_audit_dues_count.cyber['30days'].count = data.cyber['30days'].count;
    state.vessel_audit_dues_count.cyber['30days'].ids = data.cyber['30days'].ids;
    state.vessel_audit_dues_count.cyber['30days'].requesting = false;
    state.vessel_audit_dues_count.cyber['90days'].count = data.cyber['90days'].count;
    state.vessel_audit_dues_count.cyber['90days'].ids = data.cyber['90days'].ids;
    state.vessel_audit_dues_count.cyber['90days'].requesting = false;

    // state.vessel_audit_dues_count[data.params.type][data.params.due_type].count = data.data[data.params.type][data.params.due_type].count;
    // state.vessel_audit_dues_count[data.params.type][data.params.due_type].ids = data.data[data.params.type][data.params.due_type].ids;
    // state.vessel_audit_dues_count[data.params.type][data.params.due_type].requesting = false;
  },
  SET_REPORT_TYPE_STATUS_KEYS : (state, reportTypeStatusKeys) => {
    state.reportTypeStatusKeys = reportTypeStatusKeys;
  },
  SET_NONCONFORMITY_TYPE_DATA: (state, nonConformityType) => {
    state.nonConformityType[nonConformityType.type] = nonConformityType.value;
  },
  SET_OBSERVATION_TYPE_DATA: (state, observationNoteType) => {
    state.observationNoteType[observationNoteType.type] = observationNoteType.value;
  },
  SET_IA_APPOINTMENT_DETAILS: (state, ia_appointment_details) => {
    state.ia_appointment_details = ia_appointment_details;
  },
  SET_DESIGNATED_PERSON : (state, designated_persons) => {
    state.designated_persons = designated_persons;
  },
}

const getters = {
  vesselAuditRecord : state => state.vesselAuditRecord,
  selectedAuditRecord : state => state.selectedAuditRecord,
  internal_audit_reports : state => state.internal_audit_reports,
  nonConformities : state => state.nonConformities,
  nonConformityType : state => state.nonConformityType,
  observationNoteType : state => state.observationNoteType,
  root_causes_list : state => state.root_causes_list,
  latestOeLists : state => state.latestOeLists,
  oECategories : state => state.oECategories,
  director_security : state => state.director_security,
  vessel_audit_dues : state => state.vessel_audit_dues,
  vessel_audit_dues_count : state => state.vessel_audit_dues_count,
  reportTypeStatusKeys : state => state.reportTypeStatusKeys,
  ia_appointment_details : state => state.ia_appointment_details,
  designated_persons : state => state.designated_persons,
  updated_report_status_names : state => state.updated_report_status_names,
  newAppointmentAuditDueRefs: state => state.newAppointmentAuditDueRefs,
}

export default {
  state,
  actions,
  mutations,
  getters
}
